export const makeAnchor = value => value.replace(/\s+/g, "-").toLowerCase();
